// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1vE2y","calendarButtons":"ClockData_calendarButtons__KtCbp"};